import { render } from "./TabsCard.vue?vue&type=template&id=17ab3bf2&lang=pug"
import script from "./TabsCard.vue?vue&type=script&lang=js"
export * from "./TabsCard.vue?vue&type=script&lang=js"

import "./TabsCard.vue?vue&type=style&index=0&id=17ab3bf2&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__